<div class="block" #container>
  <h1>Level Term Cover with {{results.sumAssured | appcurrency}} Sum Assured</h1>
  <div class="legends">
    <div class="legend">
      <div class="bp">Benefit Payments</div>
      <div class="subtitle">Number of Benefit Payments</div>
    </div>
  </div>
  <div class="payouts" *ngIf="payout">
    <div class="chart2">
      <div class="chart">
        <div *ngFor="let series of payout; trackBy: seriesIndex" class="series"
          [style.marginBottom.px]="series.offset * 270" [style.maxHeight.px]="270 * series.height"
          [style.width.%]="100/payout.length">
          <label>{{series.index}}</label>

          <label class="top-label" *ngIf="series.topAmount !== null">
            <span class="desktop-only">{{series.topAmount | appcurrency}}</span>
            <span class="mobile-only">{{series.topAmount | appshortcurrency}}</span>
          </label>

        </div>
      </div>

      <div class="labels" [class.narrow]="payout.length > 6">
        <div class="series" *ngFor="let series of payout; trackBy: seriesIndex" [style.width.%]="100/payout.length">
          <label>{{series.name}}</label>

          <div class="amount" *ngIf="series.label !== null">
            <span class="desktop-only">{{series.label | appcurrency}}</span>
            <span class="mobile-only">{{series.label | appshortcurrency}}</span>
          </div>
        </div>
        <!-- <label>{{series.label}}</label> -->

        <!-- <label class="name" [class.rotate]="rotate" [style.zoom.%]="seriesZoom">
            <label class="index">{{series.index}}</label>
            {{series.name}}</label> -->

      </div>

    </div>

    <div class="row-line"></div>
    <div class="col-line">
      <div class="col1" [style.width.%]="100/payout.length"></div>
    </div>

  </div>

</div>
